// services/StationStateService.js
// Senaste inlästa filer + antal enheter/personer, per station (delas av alla
// administratörer som hanterar samma station).
import { fetchWithAuth } from './api';

class StationStateService {
  async getState(station) {
    if (!station || station === '---') return null;
    try {
      const response = await fetchWithAuth(`/api/stationstate?station=${encodeURIComponent(station)}`);
      if (!response.ok) {
        throw new Error('Failed to get station state');
      }
      return await response.json();
    } catch (error) {
      console.error('Error getting station state:', error);
      return null;
    }
  }

  async setDbState(field, value, station) {
    if (!station || station === '---') return null;
    const response = await fetchWithAuth(`/api/stationstate?station=${encodeURIComponent(station)}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ field, value })
    });

    if (!response.ok) {
      throw new Error(`Failed to update ${field}`);
    }

    return response.json();
  }
}

export default new StationStateService();
